import { Component, OnInit } from '@angular/core';
import { APP_CONFIG } from '../../app.config';
import { Observable } from 'rxjs';
import { ApiService, PageService } from '@gallaghercp/core-frontend';
import { NavigationEnd, Router } from '@angular/router';

@Component({
    standalone: false,
    selector: 'core-page-footer',
    templateUrl: './page-footer.component.html',
    styles: [],
})
export class PageFooterComponent implements OnInit {
    copyright = APP_CONFIG.copyright;
    pages$!: Observable<any>;
    loadedPage: any;
    destinationPage: any;
    showEntireFAQ: boolean = false;
    isCloudAcademy: boolean = false;
    hideFAQ = false;
    showHRConnect = false;
    showTwic = false;
    isLandingPageFooter = false;

    constructor(
        private pages: PageService,
        private router: Router,
        private api: ApiService,
    ) {}

    ngOnInit() {
        this.pages$ = this.pages.getAll();
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.destinationPage = event.url;
                this.loadedPage = false;
                this.checkPage();
            }
        });
        this.destinationPage = this.router.url;
        this.checkPage();
    }

    // This will get the 'destination' page from the router navigation event
    // then it will check if that page is the homepage (and show FAQ bubble regardless)
    // otherwise, it will check for the pageService to get the currentpage (if not retry in 250ms)
    // once its got the current page, it will then check page meta for 'hideFAQ' & 'ShowHRConnect'
    checkPage() {
        this.loadedPage = this.pages.getCurrentPage();
        if (this.loadedPage) {
            if (this.api.getServiceZone() !== '2') {
                this.hideFAQ = this.loadedPage.meta.hideFAQ;
                this.showHRConnect = this.loadedPage.meta.showHRConnect;
                this.showTwic = this.loadedPage.meta.showTwic;
                this.isLandingPageFooter = this.loadedPage.meta.isLandingPage;
            } else {
                this.isCloudAcademy = true;
                this.hideFAQ = true;
            }
        } else {
            setTimeout(() => {
                this.checkPage();
            }, 250);
        }
    }
}
